import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import TrainingContainer from '../components/Training/TrainingContainer';

    class Training extends React.Component {

      componentDidMount = () => {
        this.props.log('Training.js/componentDidMount');
      }
    
      render() {
        return (<Container fluid>
          <TrainingContainer {...this.props}/>
        </Container>
        );
      }
    }

export default Training;